import React from 'react';

const HomePage = () => <>
<h1>Welcome in our app</h1>
<br></br>
<h3>This is the start page</h3>
<br></br>
<p>If you want to see new articles, please choose one of the icons:</p>
<br></br>
<ol>
<li>First represents articles with highest chance to be fake news</li>
<li>Second represents articles with medium chance to be fake news</li>
<li>Third represents articles with lowest chance to be fake news</li>
</ol>
<br></br>
<p>You can also read the article' description in more comfortable way, by clicking on it's description white field - you will be be moved to new view</p>
</>;


export default HomePage;
